import React from 'react'
import Break from '../DMGComponents/Break'
import { getAreaLogs, getAreaLogsForApproval } from '../fetchData';
import toast, { Toaster } from 'react-hot-toast';
import Button from '../DMGComponents/Button';
import Spinner from './Spinner';
import AreaLogsIcon from '../assets/img/file-text.svg'; 

class AreaLogs extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isSearching: false,
            areaLogs: [],
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.area.id !== this.props.area.id) {
            this.setState({ areaLogs: [] });
        }
    }

    loadAreaLogs = () => {
        this.setState({
            isSearching: true,
            areaLogs: []
        })
        if (this.props.isApprovalMode) {
            getAreaLogsForApproval(this.props.area.id).then((res) => {
                this.fillAreaLogs(res);
            }).catch((err) => {
                this.onGetAreaLogsError(err);
            })
        }
        else {
            getAreaLogs(this.props.area.id).then((res) => {
                this.fillAreaLogs(res);
            }).catch((err) => {
                this.onGetAreaLogsError(err);
            })
        }
    }

    fillAreaLogs = (res) => {
        let arr = []
        res.forEach(u => {
            arr.push({ loginName: u.loginName, fileName: u.fileName, areaOwner: u.areaOwner, date: new Date(u.dateTimeUnixMs).toLocaleString(), action: u.action })
        });
        this.setState({
            areaLogs: arr,
            isSearching: false
        });
    }

    onGetAreaLogsError = (err) => {
        this.setState({
            isSearching: false
        });
        toast.error("Error loading logs.");
    }

    generateTableBody = () => {
        return this.state.areaLogs.map((item, index) => {
            return (
                <tr key={index} className="searchContent">
                    <td >
                        {item.loginName}
                    </td>
                    <td>
                        {item.fileName}
                    </td>
                    <td>
                        {item.date}
                    </td>
                    <td>
                        {item.action}
                    </td>
                </tr>
            )
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <Break style={{ margin: "16px 0 12px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={AreaLogsIcon}
                                alt="Area Info"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            Area Logs
                        </div>
                    </div>
                </Break>
                <div style={{ display: "flex", justifyContent: "right", marginBottom: "4px", marginTop: "8px" }}>
                    <Button type="hover-bottom-left" onClick={this.loadAreaLogs} disabled={this.state.isSearching}>Load Logs</Button>
                </div>
                {this.state.isSearching &&
                    <><div style={{ textAlign: "center" }}>
                        <Spinner />
                    </div></>
                }
                {this.state.areaLogs.length > 0 &&
                    <div>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th >Login name</th>
                                    <th >File name</th>
                                    <th >Date</th>
                                    <th >Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.generateTableBody()}
                            </tbody>
                        </table>
                        <hr style={{ margin: "30px 0" }} />
                    </div>
                }
            </div>
        );
    }
}

export default AreaLogs;